import * as ActionTypes from './navigation.actionTypes';
import { push, replace } from 'react-router-redux';

export const openMenu = () => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.OPEN,
  });
};

export const closeMenu = () => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.CLOSE,
  });
};

export const navigate = (route, replaceEntry = false) => (
  dispatch,
  getState
) => {
  const action = replaceEntry ? replace : push;
  return dispatch(action(route));
};



// WEBPACK FOOTER //
// ./src/modules/navigation/navigation.actions.js